<template>
  <div v-if="!code">
    <ui-heading tag="h3" bullet bold margin
      >{{ $t("activeEmail") }}{{ $t("emailSent") }}</ui-heading
    >
    <div class="mb20">
      {{ $t("ifActiveEmailNotReceived") }}
      <resend-email :email="emailAddress"></resend-email>
    </div>
    <div>
      <span class="color pointer" @click="skipActive" v-ui-loading="loading"
        >{{ $t("skipActivation") }}
      </span>
    </div>
  </div>
  <div v-else>
    <ui-heading tag="h4" class="heading-bullet bold"
      ><span class="color">{{ emailAddress }}</span
      >{{ $t("activingYourEmail") }}</ui-heading
    >
    <p>{{ activeText }}</p>
  </div>
</template>
<script>
import ResendEmail from "../ResendEmail.vue";
import api from "../../api/index";

export default {
  data() {
    return {
      loading: null,
      code: "",
      activeText: "",
    };
  },
  computed: {
    emailAddress() {
      if (this.email) {
        return this.email;
      } else if (this.$route.params.code) {
        return window.atob(this.$route.params.code);
      } else if (localStorage.getItem("email")) {
        return localStorage.getItem("email");
      } else {
        return "";
      }
    }
  },
  props: {
    email: {
      type: String,
      required: true
    }
  },
  components: {
    ResendEmail
  },
  mounted() {
    this.code = this.$route.params.code;
    if (this.code) {
      this.emailActivation();
      localStorage.setItem("email", this.email);
    }
  },
  methods: {
    skipActive() {
      this.loading = { color: "light" };
      api
        .skipActivation({ email: this.email })
        .then(res => {
          setTimeout(_ => {
            localStorage.removeItem("email");
            localStorage.setItem("email", this.email);
            this.$router.push("/login");
            this.$emit("skip-success");
            this.$UiToast(this.$t("activeSuccess"));
          }, 2000);
        })
        .catch(error => {
          this.$UiToast({
            message: error.response.data.msg,
            type: "error"
          });
        });
    },
    emailActivation() {
      api
        .emailActivation({ email: this.email, code: this.code })
        .then(res => {
          if (res.data.ok) {
            this.activeText = this.$t("activeSuccess");
          }
          if (res.data.msg == "alreadyActived") {
            this.activeText = this.$t("alreadyActived");
          }
          setTimeout(_ => {
            this.$router.push("/login");
          }, 2000);
        })
        .catch(error => {
          this.$UiToast({
            message: error.response.data.msg,
            type: "error"
          });
        });
    }
  }
};
</script>
